const style = (theme) => ({
  root: {
    padding: theme.spacing(2)
  },
  radioGroup: {
    display: 'flex',
    justifyContent: 'space-around'
  },
  radioLabel: {
    color: '#fff'
  }
});

export default style;
